module.exports = __webpack_public_path__ + "img/summer-pin.adae236d.png";